import { render, staticRenderFns } from "./OfflineSyncStatus.vue?vue&type=template&id=9470f366&scoped=true"
import script from "./OfflineSyncStatus.vue?vue&type=script&lang=js"
export * from "./OfflineSyncStatus.vue?vue&type=script&lang=js"
import style0 from "./OfflineSyncStatus.vue?vue&type=style&index=0&id=9470f366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9470f366",
  null
  
)

export default component.exports